<template>
  <div class="allorders">
    <div class="pop">
      <el-dialog title="订单详情"
                 :visible.sync="dialogTableVisible"
                 width="1100px"
                 class="dialogTableVisible_1">
        <div class="order_details">
          <h4 class="order_details_title">地址信息</h4>
          <el-row :gutter="5">
            <el-col :span="3">
              <div class="grid-content ">
                <div class="details_title">
                  寄件人姓名
                </div>
                <div class="details_content">
                  {{orderID.jjname||'未选择报价'}}
                </div>
              </div>
            </el-col>
            <el-col :span="4">
              <div class="grid-content ">
                <div class="details_title">
                  寄件人电话
                </div>
                <div class="details_content">
                  <span v-if="orderID.jjmobile">{{orderID.jjmobile}}</span>
                  <span v-else
                        style="color:#999">选择报价后生成</span>
                </div>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="grid-content ">
                <div class="details_title">
                  寄件详细地址
                </div>
                <div class="details_content">
                  {{orderID.jjprovince+' '+orderID.jjcity+' '+orderID.jjdistrict+' '+orderID.jjaddress}}
                </div>
              </div>
            </el-col>
            <el-col :span="3">
              <div class="grid-content ">
                <div class="details_title">
                  邮政编码
                </div>
                <div class="details_content">
                  <span v-if="orderID.jjzipcode">{{orderID.jjzipcode}}</span>
                  <span v-else
                        style="color:#999">未填写</span>
                </div>
              </div>
            </el-col>
            <el-col :span="4">
              <div class="grid-content ">
                <div class="details_title">
                  寄件公司名
                </div>
                <div class="details_content">
                  <span v-if="orderID.jjcompanyname">{{orderID.jjcompanyname}}</span>
                  <span v-else
                        style="color:#999">未填写</span>
                </div>
              </div>
            </el-col>
            <el-col :span="4">
              <div class="grid-content ">
                <div class="details_title">
                  寄件公司税号（ EORI ）
                </div>
                <div class="details_content">
                  <span v-if="orderID.jjcompanytaxid">{{orderID.jjcompanytaxid}}</span>
                  <span v-else
                        style="color:#999">未填写</span>
                </div>
              </div>
            </el-col>

            <el-col :span="3">
              <div class="grid-content ">
                <div class="details_title">
                  收件人姓名 | 代码
                </div>
                <div class="details_content">
                  {{orderID.sjname||'未选择报价'}}
                </div>
              </div>
            </el-col>

            <el-col :span="4">
              <div class="grid-content ">
                <div class="details_title">
                  收件人电话
                </div>
                <div class="details_content">
                  <span v-if="orderID.sjmobile">{{orderID.sjmobile}}</span>
                  <span v-else
                        style="color:#999">用户未选择 | FBA无需电话</span>
                </div>
              </div>
            </el-col>

            <el-col :span="6">
              <div class="grid-content ">
                <div class="details_title">
                  收件人详细地址
                </div>
                <div class="details_content">
                  {{`${orderID.gjname||''} ${orderID.sjprovince||''} ${orderID.sjcity||''} ${orderID.sjdistrict||''} ${orderID.sjaddress||''}`}}
                </div>
              </div>
            </el-col>

            <el-col :span="3">
              <div class="grid-content ">
                <div class="details_title">
                  邮政编码
                </div>
                <div class="details_content">
                  <span v-if="orderID.sjzipcode">{{orderID.sjzipcode}}</span>
                  <span v-else
                        style="color:#999">未填写</span>
                </div>
              </div>
            </el-col>

            <el-col :span="4">
              <div class="grid-content ">
                <div class="details_title">
                  收件公司名
                </div>
                <div class="details_content">
                  <span v-if="orderID.sjcompanyname">{{orderID.sjcompanyname}}</span>
                  <span v-else
                        style="color:#999">未填写</span>
                </div>
              </div>
            </el-col>

            <el-col :span="4">
              <div class="grid-content ">
                <div class="details_title">
                  收件公司税号（ EORI ）
                </div>
                <div class="details_content">
                  <span v-if="orderID.sjcompanytaxid">{{orderID.sjcompanytaxid}}</span>
                  <span v-else
                        style="color:#999">未填写</span>
                </div>
              </div>
            </el-col>

          </el-row>
          <h4 class="order_details_title">订单信息</h4>
          <el-row :gutter="5">
            <el-col :span="3">
              <div class="grid-content ">
                <div class="details_title">
                  订单ID
                </div>
                <div class="details_content">
                  <span>{{orderID.id}}</span>
                </div>
              </div>
            </el-col>

            <el-col :span="3">
              <div class="grid-content ">
                <div class="details_title">
                  订单类型
                </div>
                <div class="details_content">
                  <span>{{orderID.fromtype==1?'自寄':orderID.fromtype==2?'上门取件':'自送仓库'}}</span>
                </div>
              </div>
            </el-col>
            <el-col :span="3">
              <div class="grid-content ">
                <div class="details_title">
                  送件类型
                </div>
                <div class="details_content">
                  <span>{{orderID.fromtype==1?'自寄':orderID.fromtype==2?'上门取件':'自送仓库'}}</span>
                </div>
              </div>
            </el-col>
            <el-col :span="5">
              <div class="grid-content ">
                <div class="details_title">
                  物流单号
                </div>
                <div class="details_content">
                  <span v-if="orderID.wlnum">{{orderID.wlnum}}</span>
                  <span v-else
                        style="color:#999">集运订单选择报价后生成</span>
                </div>
              </div>
            </el-col>
            <el-col :span="5">
              <div class="grid-content ">
                <div class="details_title">
                  快递单号
                </div>
                <div class="details_content">
                  <span v-if="orderID.wlnum">{{orderID.wlnum}}</span>
                  <span v-else
                        style="color:#999">集运订单选择报价后生成</span>
                </div>
              </div>
            </el-col>
            <el-col :span="5">
              <div class="grid-content ">
                <div class="details_title">
                  转运单号
                </div>
                <div class="details_content">
                  <span v-if="orderID.zynum!=0">{{orderID.zynum}}</span>
                  <span v-else
                        style="color:#999">后台添加后显示</span>
                </div>
              </div>
            </el-col>

            <el-col :span="3">
              <div class="grid-content ">
                <div class="details_title">
                  包裹总体积
                </div>
                <div class="details_content">
                  <span v-if="orderID.tj">{{orderID.tj}} 立方厘米</span>
                  <span v-else
                        style="color:#999">待测量</span>
                </div>
              </div>
            </el-col>

            <el-col :span="3">
              <div class="grid-content ">
                <div class="details_title">
                  包裹总重量
                </div>
                <div class="details_content">
                  <span v-if="orderID.weight">{{orderID.weight}}</span>
                  <span v-else
                        style="color:#999">待测量</span>
                </div>
              </div>
            </el-col>

            <el-col :span="3">
              <div class="grid-content ">
                <div class="details_title">
                  包裹数量
                </div>
                <div class="details_content">
                  <span v-if="orderID.bgnum">{{orderID.bgnum}}</span>
                  <span v-else
                        style="color:#999">待测量</span>
                </div>
              </div>
            </el-col>

            <el-col :span="15">
              <div class="grid-content ">
                <div class="details_title">
                  下单时间
                </div>
                <div class="details_content">
                  <span>{{orderID.createtime}}</span>
                </div>
              </div>
            </el-col>

          </el-row>
          <span class="order_details_prompt">
            *如果订单信息有误需要修改，请联系客服进行告知订单ID修改。
          </span>
        </div>
        <span slot="footer"
              class="dialog-footer">
          <el-button @click="showGoodsExplain">查看物品</el-button>
          <el-button @click="showUploadFile">上传文件</el-button>
          <el-button v-if="orderID.bgfile"
                     @click="downloadFile">下载已上传的文件</el-button>

          <el-button type="primary"
                     @click="dialogTableVisible = false">取 消</el-button>
        </span>
      </el-dialog>

      <el-dialog title="物品列表"
                 :visible.sync="dialogTableVisible_2">
        <el-table :data="goodsData"
                  style="width: 100%">
          <el-table-column prop="name"
                           label="物品名"
                           width="100">
          </el-table-column>
          <el-table-column prop="enname"
                           label="英文品名"
                           width="100">
          </el-table-column>
          <el-table-column prop="num"
                           label="物品数量"
                           width="100">
          </el-table-column>
          <el-table-column prop="unitprice"
                           label="物品单价"
                           width="100">
          </el-table-column>
          <el-table-column prop="totalamount"
                           label="货物总价">
          </el-table-column>

        </el-table>
      </el-dialog>

      <el-dialog title="上传文件"
                 :visible.sync="upLoadingShow"
                 width="30%">
        <el-upload class="upload-demo"
                   :action="action"
                   :multiple='false'
                   :data='{orderid:orderID.id}'
                   name='bgfile'
                   :headers="headers"
                   :limit='1'
                   :on-exceed="exceedFile"
                   :on-remove="removeFile"
                   :on-success="successUpload"
                   :accept='accept'>
          <el-button size="small"
                     type="primary">点击上传</el-button>
          <div slot="tip"
               class="el-upload__tip">根据需求上传报关或其他文件，详情请咨询客服。</div>
        </el-upload>
        <span slot="footer"
              class="dialog-footer">
          <el-button @click="upLoadingShow = false">取 消</el-button>
          <el-button type="primary"
                     @click="upLoadingShow = false">确 定</el-button>
        </span>
      </el-dialog>
    </div>

    <!-- 查询订单 -->
    <div class="allorders_search">
      <el-form class="allorders_search_form">

        <!-- 物流单号 -->
        <el-form-item class="allorders_search_item"
                      label='物流单号'>
          <el-input placeholder="请输入物流单号"
                    v-model="queryCondition.wlnum"> </el-input>
        </el-form-item>

        <!-- 订单类型 -->
        <el-form-item class="allorders_search_item"
                      label='商业/集运'>
          <el-select v-model="queryCondition.type"
                     placeholder="查询商业/集运件">
            <el-option v-for="item in orderType"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <!-- 订单状态 -->
        <el-form-item class="allorders_search_item"
                      label='订单状态'>
          <el-select v-model="queryCondition.status"
                     placeholder="根据订单状态查询">
            <el-option v-for="item in orderStatus"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>

        <!-- 收件国家 -->
        <el-form-item class="allorders_search_item"
                      label='国家查询'>
          <div class="shipping_address">
            <el-cascader :props="props"
                         v-model="queryCondition.addrid">
            </el-cascader>
          </div>
        </el-form-item>

        <!-- 收件姓名 -->
        <el-form-item class="allorders_search_item"
                      label='收件姓名'>
          <el-input placeholder="根据收件人姓名查询"
                    v-model="queryCondition.keyword"> </el-input>
        </el-form-item>

        <!-- 快递单号 -->
        <el-form-item class="allorders_search_item"
                      label='快递单号'>
          <el-input placeholder='根据快递单号查询'
                    v-model="queryCondition.kdnum"> </el-input>
        </el-form-item>

        <!-- 仓库id -->
        <el-form-item class="allorders_search_item"
                      label='仓库查询'>
          <el-select v-model="queryCondition.ckid"
                     placeholder="根据订单状态查询">
            <el-option v-for="item in warehouseChoose"
                       :key="item.id"
                       :label="item.name"
                       :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>

        <!-- 查询按钮 -->
        <el-form-item class="allorders_search_item allorders_search_but">
          <el-button type='primary'
                     @click="trackOrder()">查询
          </el-button>
          <el-button type='info'
                     @click='resetData()'>重置
          </el-button>
        </el-form-item>

      </el-form>
    </div>
    <!-- 订单展示 -->
    <div class="orderShow">
      <el-table :data="tableData"
                style="width: 100%"
                height="85%"
                v-loading="loading">

        <el-table-column label="入仓ID"
                         width="100">
          <template slot-scope="scope">
            <span>{{scope.row.id}}</span>

          </template>
        </el-table-column>

        <el-table-column label="物流单号"
                         width="140">
          <template slot-scope="scope">
            <span v-if="scope.row.wlnum!=0">{{scope.row.wlnum}}</span>
            <span v-else
                  style="color:#999">选择报价后生成</span>
          </template>
        </el-table-column>

        <el-table-column label="订单类型"
                         width="120">
          <template slot-scope="scope">
            <span>{{scope.row.type==1?'商业':'集运'}}</span>
          </template>
        </el-table-column>

        <el-table-column prop="zt"
                         label="订单状态"
                         width="120">
        </el-table-column>
        <el-table-column label="收件国家"
                         width="200">

          <template slot-scope="scope">
            <span v-if="scope.row.gjname">{{scope.row.gjname}}</span>
            <span v-else
                  style="color:#999">选择报价后生成</span>
          </template>

        </el-table-column>
        <el-table-column label="收件姓名"
                         width="140">
          <template slot-scope="scope">
            <span v-if="scope.row.sjname">{{scope.row.sjname}}</span>
            <span v-else
                  style="color:#999">选择报价后生成</span>
          </template>

        </el-table-column>
        <el-table-column prop="kdnum"
                         width="180"
                         label="快递单号">

          <template slot-scope="scope">
            <span v-if="scope.row.kdnum">{{scope.row.kdnum}}</span>
            <span v-else
                  style="color:#999">只有自寄和打包前有</span>
          </template>
        </el-table-column>
        <el-table-column prop="ckid"
                         show-overflow-tooltip
                         label="仓库名称"
                         width="150">
          <template slot-scope="scope">
            <span>{{scope.row.ckname}}</span>

          </template>
        </el-table-column>
        <el-table-column label="操作"
                         align="right">
          <template slot-scope="scope">
            <el-button type='primary'
                       size='mini'
                       @click='orderIDdetails(scope.row.id)'>
              详情
            </el-button>
            <el-button type='primary'
                       v-if="scope.row.zt=='待支付'"
                       size='mini'
                       @click='orderPay(scope.row.id,3)'>
              支付
            </el-button>

            <!-- <el-button type='primary'
                       @click='modifyOrder(scope.row.id)'>
              修改
            </el-button> -->
          </template>
        </el-table-column>

      </el-table>
      <div class="paging">
        <el-pagination background
                       layout="prev, pager, next"
                       :total="ordernum"
                       @current-change='pageData'>
        </el-pagination>
      </div>
    </div>

  </div>
</template>

<script>
import { apiOrderStatus, apiSite, apiOrderDetails } from '@/request/api'
import { Message } from "element-ui";
import common from '@/assets/js/common'

export default {
  name: "AllOrders",
  data () {
    return {
      headers: {
        'vue': 1,
        'XTOKIN': this.$store.state.Authorization
      },
      //--------token--------
      action: this.$store.state.upUrl,
      //--------下载报关文件--------
      downloadUrl: '',
      //----------------
      updataOrderId: '',
      //--------限制上传文件--------
      accept: '.xls, .xlsx, .csv',
      //--------上传数据--------
      uploadData: {},
      //是否显示上传
      upLoadingShow: false,
      //物品数据
      goodsData: [],
      //订单类型
      orderType: [
        { label: '商业件', value: '1' },
        { label: '集运件', value: '2' }
      ],
      //当前订单状态
      statusID: 0,
      //当前显示的订单详情内容
      orderID: '',
      //是否显示订单详情
      dialogTableVisible: false,
      dialogTableVisible_2: false,
      //加载动画
      loading: true,
      //判断翻页状态
      pageStatus: 1,
      //当前页
      page: 1,
      //订单数量
      ordernum: 1,
      //订单列表
      tableData: [],
      //订单状态数组
      orderStatus: [],
      //仓库数据
      warehouseChoose: [],
      // 国家查询数据
      props: {
        lazy: true,
        options: [],
        lazyLoad (node, resolve) {
          apiSite().then(res => {
            //初始化
            if (node.level === 0) {
              let arr = []
              //处理数据
              Object.keys(res.gjlist).forEach(key => {
                arr.push(res.gjlist[key])
              })
              let nodes = []
              for (const key in arr) {
                if (arr[key].province) {
                  if (arr[key].province.length > 1) {
                    let newArr = {
                      value: arr[key].id,
                      label: arr[key].label,
                      leaf: true
                    }
                    nodes.push(newArr)
                  }
                }
              }
              this.options = nodes
            }
            resolve(this.options)
          })
        }
      },
      // 查询条件
      queryCondition: {
        // 订单状态
        status: '',
        // 国家id
        addrid: '',
        // 仓库id
        ckid: '',
        //物流单号
        wlnum: '',
        //快递单号
        kdnum: '',
        //收件人姓名
        keyword: '',
        //订单类型
        type: '',
        //订单id
        orderid: ''
      }
    }
  },

  methods: {
    //  ----------订单支付跳转-----------
    orderPay (id, is_order, payid) {
      this.$router.push({
        path: '/index/Payment',
        query: {
          id,
          payid,
          order: is_order
        }
      })
    },
    //  -----------下载报关文件-----------
    downloadFile () {
      location.href = this.downloadUrl
    },
    //  -----------上传成功回调-----------
    successUpload (e) {
      this.uploadData = e
      this.downloadUrl = e.fileurl
      this.$message(e.message)
      this.upLoadingShow = false
    },
    //  -----------移除文件-----------
    removeFile (e) {
      this.$message.success('成功移除' + e.name + '文件')

    },
    //  -----------超出提醒-----------
    exceedFile (e) {
      this.$message.error('您已经上传了' + e[0].name + '文件,请先删除。')
    },
    // -----------显示上传文件-----------
    showUploadFile (id) {
      this.updataOrderId = id
      this.upLoadingShow = true
    },
    // -----------显示物品说明-----------
    showGoodsExplain () {
      this.dialogTableVisible_2 = true
    },

    // -----------处理货币-----------
    currenctyDate (ab) {
      switch (ab) {
        case 'RUB':
          return '俄罗斯卢布'
          break;
        case 'AUD':
          return '澳大利亚元'
          break;
        case 'NLG':
          return '荷兰盾'
          break;
        case 'GBP':
          return '英镑'
          break;
        case 'FRF':
          return '法郎'
          break;
        case 'INR':
          return '印度卢比'
          break;
        case 'EUR':
          return '欧元'
          break;
        case 'CNY':
          return '人民币'
          break;
        case 'USD':
          return '美元'
          break;
        case 'VND':
          return '越南盾'
          break;
        case 'MOP':
          return '新加坡元'
          break;
        case 'JPY':
          return '日元'
          break;
        case 'KRW':
          return '韩元'
          break;
        case 'MYR':
          return '马币'
          break;
        case 'NTD':
          return '台币'
          break;
        case 'HKD':
          return '港币'
          break;
        default:
          break;
      }
    },
    // -----------处理订单状态-----------
    orderStatusID (id) {
      if (id == 0) {
        return this.statusID = 0
      } else if (3 >= id > 0) {
        return this.statusID = 1
      } else if (6 >= id > 3) {
        return this.statusID = 2
      } else if (8 >= id > 6) {
        return this.statusID = 3
      } else if (id == 9) {
        return this.statusID = 4
      } else if (id == 11) {
        return this.statusID = 5
      }
    },
    // -----------查看订单详情-----------
    async orderIDdetails (id) {
      let res = await apiOrderDetails({
        op: 'orderinfo',
        pd: 'getinfo',
        orderid: id
      })
      if (res.errno != 1) {
        this.orderID = res
        this.orderID.qjstartime = common.formatDate(this.orderID.qjstartime)
        this.orderID.createtime = common.formatDate(this.orderID.createtime)
        this.dialogTableVisible = true
        this.downloadUrl = this.orderID.bgfile
        let arr = []
        for (const key in res.xz_weight_tj) {
          arr.push(...res.xz_weight_tj[key].wpinfo)
        }
        this.goodsData = arr
      } else {
        Message.error(res.message)
      }
    },
    // -----------修改订单-----------
    async modifyOrder (id) {
      let res = await apiOrderDetails({
        op: 'orderinfo',
        pd: 'getinfo',
        orderid: id
      })
      this.$router.replace({
        name: 'OrderDetail',
        params: {
          modify: true,
          item: res
        }
      })
    },
    // -----------清除数据-----------
    resetData () {
      this.queryCondition = {
        // 订单状态
        status: '',
        // 国家id
        addrid: '',
        // 仓库id
        ckid: '',
        //物流单号
        wlnum: '',
        //快递单号
        kdnum: '',
        //收件人姓名
        keyword: ''
      }
      this.trackOrder()
    },

    // -----------查询订单-----------
    async trackOrder () {
      this.loading = true
      let res = await apiOrderStatus({
        op: 'list',
        pd: 'getlist',
        page: this.page,
        pageSize: 10,
        //  类型
        type: this.queryCondition.type,
        // 订单状态
        cxzt: this.queryCondition.status,
        // 国家id
        addrid: this.queryCondition.addrid[0],
        // 仓库id
        ckid: this.queryCondition.ckid,
        //物流单号
        wlnum: this.queryCondition.wlnum,
        //快递单号
        kdnum: this.queryCondition.kdnum,
        //收件人姓名
        keyword: this.queryCondition.keyword,
        //订单id
        orderid: this.queryCondition.orderid
      })
      this.tableData = res.orderlist
      this.pageStatus = 2
      this.ordernum = parseInt(res.totalNum)
      this.loading = false

    },
    // -----------获取订单状态数据-----------
    async getOrderStatus () {
      this.loading = true
      let res = await apiOrderStatus({
        op: 'list',
        pd: 'getlist',
        page: this.page,
        pageSize: 10,
        orderid: this.queryCondition.orderid

      })

      this.orderStatus = [{
        value: 'dqd',
        label: '待确定'
      }, {
        value: 'drk',
        label: '待入库'
      }, {
        value: 'dfk',
        label: '待付款'
      }, {
        value: 'dck',
        label: '待出库'
      }, {
        value: 'zyz',
        label: '转运中'
      }, {
        value: 'ybg',
        label: '已报关'
      }, {
        value: 'yqg',
        label: '已清关'
      }, {
        value: 'pjz',
        label: '派件中'
      }, {
        value: 'bfqs',
        label: '部分签收'
      }, {
        value: 'yqs',
        label: '已签收'
      }, {
        value: 'wtj',
        label: '问题件'
      },]


      this.tableData = res.orderlist
      this.warehouseChoose = res.cklist
      this.ordernum = parseInt(res.totalNum)
      // this.processingData(res)
      this.loading = false
    },



    // -----------页数跳转-----------
    pageData (e) {
      this.page = e
      if (this.pageStatus === 1) {
        this.getOrderStatus()
        this.page = 1
      } else if (this.pageStatus === 2) {
        this.trackOrder()
        this.page = 1
      }

    }
  },
  mounted () {
    if (this.$route.query.id) {
      console.log(111);
      this.queryCondition.orderid = this.$route.query.id
    }

    this.getOrderStatus()
  }
}
</script>

<style lang="scss">
@import "@/assets/css/variable.scss";

.allorders {
  width: 100%;
  height: 100%;
  // padding: 20px;
  box-sizing: border-box;
  // background-color: pink;
  flex-direction: column;
  display: flex;
  align-items: center;
  overflow: auto;
  // justify-content: center;
  .order_details {
    width: 100%;
    height: 600px;
    // border: 1px solid #eee;
    .order_details_prompt {
      color: #999;
      font-size: 12px;
    }
    .order_details_title {
      margin-bottom: 5px;
    }
    .el-row {
      margin-bottom: 20px;
      &:last-child {
        margin-bottom: 0;
      }
    }
    .el-col {
      border-radius: 4px;
    }
    .grid-content:hover {
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
    }
    .grid-content {
      box-shadow: 0;
      border-radius: 4px;
      min-height: 36px;
      border: 1px solid #eee;
      height: 80px;
      margin-bottom: 5px;
      display: flex;
      flex-direction: column;
      transition: all 0.3s;
      .details_title {
        font-weight: 700;
        flex: 1;
        display: flex;
        align-items: center;
        box-sizing: border-box;
        padding-left: 5px;
        color: #999;
        background-color: #f9f9f9;
      }
      .details_content {
        flex: 1;
        padding-left: 5px;
        display: flex;
        align-items: center;
      }
    }
    .row-bg {
      padding: 10px 0;
      background-color: #f9fafc;
    }
  }
  .el-table--border::after,
  .el-table--group::after,
  .el-table::before {
    background-color: #fff;
  }
  .dialogTableVisible_1 {
    .orderShow_btn {
      width: 100%;
      background-color: pink;
      // display: flex;
      position: relative;
      // justify-content: right;
      .el-button {
        position: absolute;
        right: 0;
        top: -20px;
      }
    }
  }
  .allorders_title {
    width: 100%;
    height: 30px;
    padding-left: 2.5%;
    box-sizing: border-box;
    display: flex;
    justify-content: left;
    align-items: center;
    // border-bottom: 2px dashed #cccccc;
    transition: all 0.3s;
    background-color: #ffffff;
  }
  .allorders_search {
    width: 95%;
    margin: 10px;
    height: 150px;
    padding: 20px;
    box-sizing: border-box;
    background-color: #fff;
    .allorders_search_form {
      height: 100%;
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      .allorders_search_item {
        width: 25%;
        height: 40%;
        .el-input {
          width: 40%;
        }
        .el-select,
        .el-cascader {
          .el-input {
            width: 90%;
          }
        }
        .el-input__inner {
          height: 30px !important;
        }
      }
      .allorders_search_but {
        width: 40%;
        // background-color: pink;
        text-align: right;
        button {
          margin-left: 50px;
        }
      }
    }
  }
  .orderShow {
    width: 95%;
    height: 75%;
    // padding: /;
    background-color: #fff;

    .paging {
      width: 100%;
      height: 10%;
      min-height: 80px;
      background-color: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .cell {
      padding-left: 50px;
    }
  }
  .el-table--enable-row-hover .el-table__body tr:hover > td {
    background-color: rgb(185, 175, 175) !important;
    color: #fff;
  }
  .el-table--enable-row-hover .el-table__body tr td {
    transition: none !important;
  }
}
</style>